import React from "react";
import Button from "@mui/material/Button";
import ItemFormModal from "./ItemFormModal";
import { Box, FormHelperText } from "@mui/material";

const AddLineItemButton = ({
  errors,
  addItem,
  buttonText = "+ Add Line Item",
  name = "document_lines",
  lineItems,
  transactionType = null,
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = (data) => {
    addItem({ ...data, key: data?.key || Date.now() });
    handleClose();
  };

  const getDocumentLineErrorMessages = (errors, name = "document_lines") => {
    const documentLines = errors?.[name];

    if (!documentLines) {
      return [];
    }

    // document_lines itself has an error
    if (!Array.isArray(documentLines)) {
      return documentLines.message ? [documentLines.message] : [];
    }

    // Individual document line errors
    const messages = [];

    const collectMessages = (value) => {
      if (!value || typeof value !== "object") {
        return;
      }

      if (typeof value.message === "string") {
        messages.push(value.message);
      }

      Object.values(value).forEach((child) => {
        if (child && typeof child === "object") {
          collectMessages(child);
        }
      });
    };

    documentLines.forEach(collectMessages);

    return messages;
  };

  const documentLineErrors = getDocumentLineErrorMessages(errors, name);

  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" gap={1}>
        <Button id="add-line-item" variant="contained" onClick={handleOpen}>
          {buttonText}
        </Button>
        {documentLineErrors.length > 0 && (
          <Box>
            {documentLineErrors.map((message, index) => (
              <FormHelperText key={index} error sx={{ m: 0 }}>
                {message}
              </FormHelperText>
            ))}
          </Box>
        )}
      </Box>
      <ItemFormModal
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        transactionType={transactionType}
      />
    </React.Fragment>
  );
};

export default AddLineItemButton;
